"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var material_1 = require("@angular/material");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_de_core_frontend_2 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var entity_search_item_1 = require("../../model/entity-search-item");
var SisEntitySearchComponent = /** @class */ (function () {
    function SisEntitySearchComponent(kbService, httpEntitySearchService) {
        this.ngUnsubscribe = new Subject_1.Subject();
        this.selectedEntities = [];
        this.DEFAULT_ROWS_COUNT = 10;
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.DEFAULT_FUZZINESS = 1;
        this.valueChange = new core_1.EventEmitter();
        this.filteredEntities = [];
        this.entities = [];
        // filterable entity metafields
        // uses to parse response, to know multilingual fields
        this.multilingualFields = [];
        this.nameFieldIds = [];
        this.searchValue = '';
        this.isLoaderActive = false;
        this.kbService = kbService;
        this.httpEntitySearchService = httpEntitySearchService;
        this.entitySearchCtrl = new forms_1.FormControl();
    }
    SisEntitySearchComponent.prototype.initFilteredCategoryInstanceFieldName = function (metaFields) {
        var integerInstanceMetaField = metaFields.find(function (metaField) { return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; });
        if (integerInstanceMetaField) {
            this.categoryIdentityFieldSystemName = integerInstanceMetaField.getSystemName();
        }
        else {
            throw new Error("Given " + this.filterableEntity + " Category has no Instance Id");
        }
    };
    SisEntitySearchComponent.prototype.initEntitySearchInputFilterChangeHandler = function (singleSelect) {
        var _this = this;
        //in case of change filterableEntity from output unsubscribe previous valueChanges of FormControl
        if (this.valueChangesSubscription) {
            this.valueChangesSubscription.unsubscribe();
        }
        this.valueChangesSubscription = this.entitySearchCtrl.valueChanges.pipe(operators_1.debounceTime(500))
            .mergeMap(function (value) {
            var searchingValue = value;
            if (_this.entitySearchCtrl.value instanceof entity_search_item_1.EntitySearchItem) { //(event from selection)in case of singleSelect control set search value to display name otherwise empty string to load all values
                singleSelect ? searchingValue = _this.entitySearchCtrl.value.displayName : searchingValue = '';
                //issue in material(when selecting searched item, list disappeared)
                _this.entitySearchCtrl.disable({ emitEvent: false });
            }
            return _this.loadEntities(searchingValue);
        })
            .map(function (value) {
            return _this.inputFilter(value);
        }).pipe(operators_1.takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
            _this.filteredEntities = data;
            //issue in material(when selecting searched item, list disappeared)
            _this.entitySearchCtrl.enable({ emitEvent: false });
        });
    };
    SisEntitySearchComponent.prototype.checkingFilterFieldsTypes = function (metaFields) {
        var _this = this;
        if (this.filterFields) {
            var metaFieldsMap_1 = new Map();
            metaFields.forEach(function (metaField) {
                if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
                    _this.multilingualFields.push(metaField.getMetaFieldId().getSystemName());
                }
                metaFieldsMap_1.set(metaField.getSystemName(), metaField);
            });
            this.filterFields.forEach(function (filterField) {
                if (!metaFieldsMap_1.get(filterField)) {
                    throw new Error("Given " + filterField + " metaFiled's systemName is wrong.");
                }
                else if (metaFieldsMap_1.get(filterField).getType() !== idm_kb_service_client_js_1.MetaFieldType.STRING && metaFieldsMap_1.get(filterField).getType() !==
                    idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
                    throw new Error("Given " + filterField + " metaFiled's type is wrong. MetaFields' type must be either STRING or MULTILINGUAL_STRING");
                }
            });
        }
    };
    SisEntitySearchComponent.prototype.initSortingOption = function (metaFields) {
        var _this = this;
        if (this.nameFieldIds && this.nameFieldIds.length > 0) {
            var nameMetaField_1 = this.nameFieldIds[0];
            metaFields.forEach(function (metaField) {
                if (metaField.getSystemName() == nameMetaField_1.getSystemName()) {
                    switch (metaField.getType()) {
                        case idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY:
                        case idm_kb_service_client_js_1.MetaFieldType.INTEGER:
                        case idm_kb_service_client_js_1.MetaFieldType.STRING:
                        case idm_kb_service_client_js_1.MetaFieldType.DATE:
                        case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
                        case idm_kb_service_client_js_1.MetaFieldType.BOOLEAN:
                        case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                        case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                        case idm_kb_service_client_js_1.MetaFieldType.DECIMAL:
                        case idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL:
                        case idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE:
                        case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE:
                        case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME:
                        case idm_kb_service_client_js_1.MetaFieldType.MULTILINESTRING:
                            _this.sortingOption = new idm_de_core_frontend_1.SortingOptions(metaField.getSystemName(), idm_de_core_frontend_1.SortType.ASC);
                            break;
                        case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING:
                            _this.sortingOption = new idm_de_core_frontend_1.SortingOptions(metaField.getSystemName() + "." + _this.currentLanguageId, idm_de_core_frontend_1.SortType.ASC);
                            break;
                    }
                }
            });
        }
    };
    SisEntitySearchComponent.prototype.inputFilter = function (value) {
        this.totalRows = value.getTotalRowCount() || 0;
        var values = value.getData();
        if (values !== undefined && values !== null && values.length > 0) {
            this.entities = values;
        }
        else {
            this.entities = [];
        }
        this.isLoaderActive = false;
        return this.entities;
    };
    SisEntitySearchComponent.prototype.scrollFilter = function (value) {
        this.totalRows = value.getTotalRowCount() || 0;
        var values = value.getData();
        if (values !== undefined && values !== null && values.length > 0) {
            this.entities.push.apply(this.entities, values);
        }
        else {
            this.entities = [];
        }
        this.isLoaderActive = false;
        return this.entities;
    };
    SisEntitySearchComponent.prototype.getMultiFieldFilterCriteria = function (searchableValue, languageId) {
        var _this = this;
        var mainFilterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        if (!!searchableValue && this.filterFields !== undefined && this.filterFields !== null) {
            var filterFieldsWithLanguageId_1 = [];
            this.filterFields.forEach(function (filterField) {
                if (_this.multilingualFields.indexOf(filterField) > -1) {
                    filterFieldsWithLanguageId_1.push(filterField.concat('.').concat(languageId + ''));
                }
                else {
                    filterFieldsWithLanguageId_1.push(filterField);
                }
            });
            (searchableValue !== undefined && searchableValue !== null && searchableValue.trim() !== '') &&
                mainFilterBuilder.multifield(new idm_de_core_frontend_2.MultifieldFilterCriteriaModel(searchableValue.trim(), filterFieldsWithLanguageId_1, (this.fuzziness !== undefined && this.fuzziness !== null) ? this.fuzziness : this.DEFAULT_FUZZINESS));
        }
        var exceptEntities = [];
        if (this.selectedEntities.length > 0) {
            this.selectedEntities.forEach(function (selectedEntity) {
                exceptEntities.push(selectedEntity.id);
            });
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            var notFilterCriteria = new idm_de_core_frontend_2.NotFilterCriteria(idm_de_core_frontend_2.FilterOperator.AND, filterBuilder.in(this.categoryIdentityFieldSystemName, exceptEntities).build());
            mainFilterBuilder.and(notFilterCriteria);
        }
        return mainFilterBuilder.build();
    };
    SisEntitySearchComponent.prototype.scrollEventHandler = function (event) {
        var _this = this;
        // if exists more elements
        if (this.totalRows > this.rowsToShow && this.isInRangeOfLastElementSize(event)) {
            this.rowsToShow += this.DEFAULT_ROWS_COUNT;
            this.isLoaderActive = true;
            this.loadEntities(this.searchValue).pipe(operators_1.takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
                _this.scrollFilter(data);
            });
        }
    };
    SisEntitySearchComponent.prototype.resetRowCount = function () {
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
    };
    SisEntitySearchComponent.prototype.loadEntities = function (searchingValue) {
        this.searchValue = searchingValue;
        var pagingOptions = new idm_de_core_frontend_1.PagingOptions((this.rowsToShow - this.DEFAULT_ROWS_COUNT) / this.DEFAULT_ROWS_COUNT, this.DEFAULT_ROWS_COUNT);
        return this.httpEntitySearchService.loadEntitySearchItems(this.filterableEntity, this.filterFields, this.multilingualFields, this.nameFieldIds, this.categoryIdentityFieldSystemName, this.currentLanguageId, pagingOptions, searchingValue ? undefined : this.sortingOption, this.getMultiFieldFilterCriteria(searchingValue, this.currentLanguageId), null, this.kbPrefix);
    };
    SisEntitySearchComponent.prototype.reset = function () {
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.multilingualFields = [];
    };
    SisEntitySearchComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SisEntitySearchComponent.prototype.isInRangeOfLastElementSize = function (event) {
        var RANGE_OF_ROW_HEIGHT = 8;
        var allRowsTotalHeight = this.rowsToShow * SisEntitySearchComponent.ELEMENT_ROW_SIZE;
        var element = event.target;
        var fullHeight = element.scrollTop + element.offsetHeight; // top hidden part height + autocomplete showed part height
        // checks, if current scroll position is in range of last element of the list
        return (fullHeight >= allRowsTotalHeight -
            RANGE_OF_ROW_HEIGHT) /*&& (fullHeight <= allRowsTotalHeight + RANGE_OF_ROW_HEIGHT)*/;
    };
    SisEntitySearchComponent.prototype.trackByEntities = function (index, item) {
        return item.id;
    };
    SisEntitySearchComponent.prototype.trackByFilteredEntities = function (index, item) {
        return item.id;
    };
    SisEntitySearchComponent.ELEMENT_ROW_SIZE = 36; // each entity row height is 36px
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisEntitySearchComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisEntitySearchComponent.prototype, "titleKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisEntitySearchComponent.prototype, "filterableEntity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisEntitySearchComponent.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisEntitySearchComponent.prototype, "filterFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisEntitySearchComponent.prototype, "fuzziness", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisEntitySearchComponent.prototype, "kbPrefix", void 0);
    __decorate([
        core_1.ViewChild('entitiesInput', { read: material_1.MatAutocompleteTrigger }),
        __metadata("design:type", material_1.MatAutocompleteTrigger)
    ], SisEntitySearchComponent.prototype, "autoComplete", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisEntitySearchComponent.prototype, "valueChange", void 0);
    return SisEntitySearchComponent;
}());
exports.SisEntitySearchComponent = SisEntitySearchComponent;
//# sourceMappingURL=sis-entity-search.component.js.map